import PropTypes from 'prop-types'
import React, { Component } from 'react'
// import styles from './Styles.jsx'
import {
    // Button,
    // Container,
    // Divider,
    // Grid,
    // Header,
    // Icon,
    // Image,
    // List,
    Menu,
    Responsive,
    Segment,
    // Sidebar,
    Visibility,
} from 'semantic-ui-react'
import HomepageHeading from './Head.jsx'
import MenuItems from './MenuItems'


class DesktopContainer extends Component {
    state = {}
  
    hideFixedMenu = () => this.setState({ fixed: false })
    showFixedMenu = () => this.setState({ fixed: true })
  
    render() {
      const { children } = this.props
      const { fixed } = this.state
  
      return (
        <Responsive  minWidth={769}>
        <section id='home'>
          <Visibility once={false} onBottomPassed={this.showFixedMenu} onBottomPassedReverse={this.hideFixedMenu}>
            <Segment inverted textAlign='center' style={{ minHeight: 700, padding: '1em 0em', background:'center center no-repeat', backgorundSize:'cover', backgroundImage:'url(img/header-bg.jpg)' }} vertical>
              <Menu
                fixed={fixed ? 'top' : null}
                inverted={true}
                pointing={!fixed}
                secondary={!fixed}
                size='large'
              >
              
                
                  <MenuItems />

              </Menu>
              <HomepageHeading />
            </Segment>
          </Visibility>
          </section>
  
          {children}
        </Responsive>
      )
    }
  }
  
  DesktopContainer.propTypes = {
    children: PropTypes.node,
  }

  export default DesktopContainer


// WEBPACK FOOTER //
// ./src/components/DesktopContainer.jsx